// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2c9a9c29","455":"572fe96f","977":"4382dbb1"}[chunkId] + ".chunk.js";
};